import cn from 'classnames'

import { TermsConditionsProps } from './TermsConditions.types'

export const TermsConditions = (props: TermsConditionsProps) => {
    const { className } = props

    return (
        <section className={cn('py-24 md:py-32 bg-gradient-to-b from-gray-50 to-white', className)}>
            <div className='container mx-auto px-4 max-w-4xl'>
                <div className='mb-12'>
                    <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4'>
                        Terms & Conditions
                    </h1>
                    <p className='text-gray-600'>Last updated on 23 April 2024</p>
                </div>

                <div className='bg-white rounded-lg shadow-lg p-8 md:p-12 prose prose-lg max-w-none'>
                    <p className='text-gray-700 mb-8'>
                        Welcome to nexly ("we" or "us"). These Terms and Conditions ("Terms") govern your use of our website and services. By accessing or using our website, you agree to be bound by these Terms.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>1. Acceptance of Terms</h2>
                    <p className='text-gray-700 mb-4'>
                        By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>2. Use License</h2>
                    <p className='text-gray-700 mb-4'>
                        Permission is granted to temporarily download one copy of the materials on nexly's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                    </p>
                    <ul className='list-disc list-inside text-gray-700 mb-4 space-y-2'>
                        <li>Modify or copy the materials</li>
                        <li>Use the materials for any commercial purpose or for any public display</li>
                        <li>Attempt to decompile or reverse engineer any software contained on nexly's website</li>
                        <li>Remove any copyright or other proprietary notations from the materials</li>
                    </ul>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>3. Disclaimer</h2>
                    <p className='text-gray-700 mb-4'>
                        The materials on nexly's website are provided on an 'as is' basis. nexly makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>4. Limitations</h2>
                    <p className='text-gray-700 mb-4'>
                        In no event shall nexly or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on nexly's website, even if nexly or a nexly authorized representative has been notified orally or in writing of the possibility of such damage.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>5. Accuracy of Materials</h2>
                    <p className='text-gray-700 mb-4'>
                        The materials appearing on nexly's website could include technical, typographical, or photographic errors. nexly does not warrant that any of the materials on its website are accurate, complete, or current. nexly may make changes to the materials contained on its website at any time without notice.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>6. Links</h2>
                    <p className='text-gray-700 mb-4'>
                        nexly has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by nexly of the site. Use of any such linked website is at the user's own risk.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>7. Modifications</h2>
                    <p className='text-gray-700 mb-4'>
                        nexly may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>8. Governing Law</h2>
                    <p className='text-gray-700 mb-4'>
                        These terms and conditions are governed by and construed in accordance with the laws of Luxembourg and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>9. Contact Us</h2>
                    <p className='text-gray-700 mb-4'>
                        If you have any questions about these Terms & Conditions, please contact us at{' '}
                        <a href='mailto:sales@nexly.tech' className='text-primary hover:text-primary-hover'>
                            sales@nexly.tech
                        </a>
                    </p>
                </div>
            </div>
        </section>
    )
}
